import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class CompanyEmailAddress extends RestApiModel {
  static getResourceEndpoint() {
    return '/companies/email-addresses';
  }

  static getOptions() {
    return api.get(this.getResourceEndpoint() + '/options');
  }

}

export default CompanyEmailAddress;
